import {GradebookModel} from '../../../../data/models/Course/Gradebook';
import {hasValue} from '../../../../utils/typecheck';
import {
  AvgScores,
  GRADE_FAIL,
  GRADE_SUCCESS,
  LearnersScores,
  TableHeaderItem,
} from '../../components/GradesTable';

export interface MappedGradebook {
  headerItems: TableHeaderItem[];
  avgScores: AvgScores;
  learnerRecords: LearnersScores[];
  passingScore?: number;
}

export const mapGradebook = (gradebook: GradebookModel): MappedGradebook => {
  return {
    headerItems: gradebook.lessons.map(lesson => ({
      title: lesson.title,
      id: lesson.lessonId,
    })),
    avgScores: calculateAvgGrades(gradebook),
    learnerRecords: getLearnerRecords(gradebook),
    passingScore: gradebook.coursePassingScore,
  };
};

const getGradesForLearner = (learnerId: string, gradebook: GradebookModel) => {
  const scores: any = {};
  Object.keys(gradebook!.grades).forEach(lessonKey => {
    const learnerGrades = gradebook!.grades[lessonKey].filter(
      x => x.learnerId === learnerId,
    );

    learnerGrades.forEach(grade => {
      if (
        grade.isGradable &&
        hasValue(grade.passingScore) &&
        hasValue(grade.grade)
      ) {
        scores[lessonKey] = {
          grade: grade.grade,
          status:
            grade.grade! >= grade.passingScore! ? GRADE_SUCCESS : GRADE_FAIL,
        };
      } else if (!grade.isGradable && grade.isFinished) {
        scores[lessonKey] = {
          grade: null,
          status: GRADE_SUCCESS,
        };
      }
    });
  });
  return scores;
};

const getLearnerRecords = (gradebook: GradebookModel) => {
  return gradebook.learners.map(learner => {
    const scores = getGradesForLearner(learner.learnerId, gradebook);
    return {
      scores: scores,
      id: learner.learnerId,
      name: learner.name,
      avatarUrl: undefined,
      avgGrade: calculateAvgScore(scores),
    };
  });
};

const calculateAvgScore = (scores: any) => {
  let summ = 0;
  let count = 0;
  Object.keys(scores).forEach(key => {
    if (hasValue(scores[key]?.grade)) {
      summ += scores[key].grade!;
      count++;
    }
  });
  if (count > 0) {
    return Math.round(summ / count) + '%';
  }
  return '-';
};

const calculateAvgGrades = (gradebook: GradebookModel) => {
  const avgGrades: any = {scores: {}};
  let summ = 0;
  let count = 0;
  gradebook!.lessons.forEach(lesson => {
    const lessonGrades = gradebook!.grades[lesson.lessonId];
    if (lessonGrades && lessonGrades.length && lessonGrades[0].isGradable) {
      let lessonSumm = 0;
      let lessonCount = 0;
      lessonGrades.forEach(grade => {
        if (hasValue(grade.grade)) {
          lessonSumm += grade.grade!;
          lessonCount++;
        }
      });
      if (lessonCount > 0) {
        avgGrades.scores[lesson.lessonId] = {
          grade: lessonSumm / lessonCount,
          status:
            lessonSumm / lessonCount >= (lessonGrades[0].passingScore || 50)
              ? GRADE_SUCCESS
              : GRADE_FAIL,
        };
        summ += lessonSumm / lessonCount;
        count++;
      }
    }
  });
  if (count) {
    avgGrades.overallAvgScore = summ / count;
  }
  return avgGrades;
};
